import {LOGBOOK_LOAD_REQUEST, LOGBOOK_LOAD_SUCCESS, LOGBOOK_LOAD_SUCCESS_NO_DATA, LOGBOOK_AVAILABLE_ASSIGNEES_SUCCESS} from "../config/actions";

const INIT_STATE = {
    entries: [],
    lastUpdateCall: null,
    lastUpdatedAt: null,
    loading: false,
    availableAssignees: []
};

const logbookReducer = (state = INIT_STATE, action) => {
    switch (action.type) {
        case LOGBOOK_LOAD_REQUEST:
            return {
                ...state,
                lastUpdateCall: new Date(),
                loading: true
            };
        case LOGBOOK_LOAD_SUCCESS:
            return {
                ...state,
                lastUpdatedAt: new Date(),
                entries: action.payload,
                loading: false
            };
        case LOGBOOK_LOAD_SUCCESS_NO_DATA:
            return {
                ...state,
                loading: false
            };
        case LOGBOOK_AVAILABLE_ASSIGNEES_SUCCESS:
            return {
                ...state,
                availableAssignees: action.payload
            };
        default:
            return state;
    }
};

export default logbookReducer;
